import { ChangeDetectionStrategy, Component } from "@angular/core";
import { UIState } from "@dtm-frontend/shared/ui";
import { Store } from "@ngxs/store";
import { REPORTING_VIOLATIONS_VIA_CEUPT_URL, REPORTING_VIOLATIONS_VIA_PANSA_URL } from "../../../../utils/defaults";
import { BROCHURE_FILE } from "../kpo.data";

@Component({
    selector: "dtm-main-page-lib-kpo-about-project",
    templateUrl: "./about-project.component.html",
    styleUrls: ["../../shared.scss", "./about-project.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AboutProjectComponent {
    protected readonly activeLanguage$ = this.store.select(UIState.activeLanguage);
    protected readonly BROCHURE_FILE = BROCHURE_FILE;
    protected readonly REPORTING_VIOLATIONS_VIA_PANSA_URL = REPORTING_VIOLATIONS_VIA_PANSA_URL;
    protected readonly REPORTING_VIOLATIONS_VIA_CEUPT_URL = REPORTING_VIOLATIONS_VIA_CEUPT_URL;

    constructor(private readonly store: Store) {}
}
